import axios from "axios";
import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import HorseDetail from "../../Modal/HorseModal";
import TrainerDetail from '../../Modal/TrainerModal';
import OwnerDetail from '../../Modal/OwnerModal';
import JockeyDetail from '../../Modal/JockeyModal';
import { useTranslation } from 'react-i18next';
import finderImage from "../../../../Webiste/assets/Quickfinder.png"
import Animate from "../../../assets/loader.json"
import Lottie from 'lottie-react';
import Cookies from "js-cookie";


import { getBaseUrl } from "../../../service/apiUrl";
const Search = () => {
  const navigate = useNavigate();
  const [item, SearchData] = useState("");
  const [Data, setData] = useState([]);
  const [Data2, setData2] = useState([]);
  const [Data3, setData3] = useState([]);
  const [Data4, setData4] = useState([]);
  const { t } = useTranslation()

  const [LoaderData, setLoaderData] = useState(false);
  const cookiedata = Cookies.get("i18next");

  const [show, setShow] = useState(false);
  const [modaldata, setmodaldata] = useState();
  const handleClose = () => setShow(false);
  const handleShow = (data) => {
    const id = data?._id || data;
    SearchData('');
    if (id) navigate("/horse-detail?" + id);
  };

  const [showJocley, setShowJockey] = useState(false);
  const [modaldataJockey, setmodaldataJockey] = useState();
  const handleCloseJockey = () => setShowJockey(false);
  const handleShowJocley = async (data) => {
    setmodaldataJockey(data);
    SearchData('')
    await setShowJockey(true);
  };

  const [showtrainer, setShowtrainer] = useState(false);
  const [modaldatatrainer, setmodaldatatrainer] = useState();
  const handleClosetrainer = () => setShowtrainer(false);
  const handleShowtrainer = async (data) => {
    setmodaldatatrainer(data);
    SearchData('')
    await setShowtrainer(true);
  };


  const [showowner, setShowowner] = useState(false);
  const [modaldataowner, setmodaldataowner] = useState();
  const handleCloseowner = () => setShowowner(false);
  const handleShowowner = async (data) => {
    setmodaldataowner(data);
    SearchData('')
    await setShowowner(true);
  };

  const searchChildRef = useRef(null);

  const handleClickOutside = (event) => {
    if (searchChildRef.current && !searchChildRef.current.contains(event.target)) {
      SearchData("");
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside);
    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (item !== "") {
      (async () => {
        try {
          setLoaderData(true)
          const res = await axios.post(
            `${getBaseUrl()}/searchhorse_trainer_jockey`,
            { Query: item }
          );
          setData(res.data.data1);
          setData2(res.data.data2);
          setData3(res.data.data3);
          setData4(res.data.data4);
          setLoaderData(false);

          if (item === "") {
            setData([]);
            setData2([]);
            setData3([]);
            setData4([]);
          }
        } catch (err) {

        }
      })();
    }

  }, [item]);



  return (
    <div className="new-searchparent-container">
      <div className="new-search-main-box">
        <span className="new-quick-finder-label">{t("Quick Finder")}</span>
        
        {/* SVG Icon similar to your UI */}
        <div className="new-search-icon-wrapper">
          <img src={finderImage} alt="" srcset="" style={{height: "20px" }} />
          {/* <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M11 19C15.4183 19 19 15.4183 19 11C19 6.58172 15.4183 3 11 3C6.58172 3 3 6.58172 3 11C3 15.4183 6.58172 19 11 19Z" stroke="#8E8E8E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M21 21L16.65 16.65" stroke="#8E8E8E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M8 9H14" stroke="#8E8E8E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            <path d="M8 13H12" stroke="#8E8E8E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg> */}
        </div>

        <input
          type="text"
          className="new-search-input-field"
          value={item}
          onChange={(event) => SearchData(event.target.value)}
          placeholder={t("Search Horse, Jockey, Trainer, Owner, Race..")}
        />
      </div>

      {/* Results Dropdown Section */}
      <div className={item === "" ? "new-search-dropdown-hidden" : "new-search-dropdown-visible"} ref={searchChildRef}>
        <div className="new-search-results-content">
          {!LoaderData ? (
            <>
              {/* Desktop/Laptop View: Row-based tabular layout */}
              <div className="new-desktop-view">
                <div className="new-data-row header-row" style={{ borderBottom: 'none', paddingBottom: '0' }}>
                  <div className="new-result-column"><h5 className="new-result-header">{t('Horses')}</h5></div>
                  <div className="new-result-column"><h5 className="new-result-header">{t('Jockey')}</h5></div>
                  <div className="new-result-column"><h5 className="new-result-header">{t('Trainer')}</h5></div>
                  <div className="new-result-column"><h5 className="new-result-header">{t('Owner')}</h5></div>
                </div>
                <hr className="new-divider" />
                
                <div className="new-results-container">
                  {Math.max(Data.length, Data2.length, Data3.length, Data4.length) === 0 ? (
                    <p className="new-no-data" style={{textAlign: 'center', padding: '20px'}}>{t('NoDataFound')}</p>
                  ) : (
                    Array.from({ length: Math.max(Data.length, Data2.length, Data3.length, Data4.length) }).map((_, index) => (
                      <div key={index} className="new-data-row">
                        <div className="new-result-column">
                          {Data[index] && (
                            <p className="new-data-item" onClick={() => handleShow(Data[index])}>
                              {cookiedata === "en" ? window.textTransform(Data[index]?.NameEn) : Data[index].NameAr}
                            </p>
                          )}
                        </div>
                        <div className="new-result-column">
                          {Data4[index] && (
                            <p className="new-data-item" onClick={() => handleShowJocley(Data4[index])}>
                              {cookiedata === "en" ? window.textTransform(Data4[index]?.NameEn) : Data4[index].NameAr}
                            </p>
                          )}
                        </div>
                        <div className="new-result-column">
                          {Data2[index] && (
                            <p className="new-data-item" onClick={() => handleShowtrainer(Data2[index])}>
                              {cookiedata === "en" ? window.textTransform(Data2[index]?.NameEn) : Data2[index].NameAr}
                            </p>
                          )}
                        </div>
                        <div className="new-result-column">
                          {Data3[index] && (
                            <p className="new-data-item" onClick={() => handleShowowner(Data3[index])}>
                              {cookiedata === "en" ? <>{Data3[index].TitleEn} {window.textTransform(Data3[index]?.NameEn)} </> : <>{Data3[index].TitleAr} {Data3[index].NameAr} </>}
                            </p>
                          )}
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>

              {/* Mobile View: Category-grouped layout */}
              <div className="new-mobile-view">
                {Data.length > 0 && (
                  <div className="mobile-category-section">
                    <h5 className="new-result-header">{t('Horses')}</h5>
                    {Data.map((item, idx) => (
                      <p key={idx} className="new-data-item" onClick={() => handleShow(item)}>
                        {cookiedata === "en" ? window.textTransform(item?.NameEn) : item.NameAr}
                      </p>
                    ))}
                  </div>
                )}
                {Data4.length > 0 && (
                  <div className="mobile-category-section">
                    <h5 className="new-result-header">{t('Jockey')}</h5>
                    {Data4.map((item, idx) => (
                      <p key={idx} className="new-data-item" onClick={() => handleShowJocley(item)}>
                        {cookiedata === "en" ? window.textTransform(item?.NameEn) : item.NameAr}
                      </p>
                    ))}
                  </div>
                )}
                {Data2.length > 0 && (
                  <div className="mobile-category-section">
                    <h5 className="new-result-header">{t('Trainer')}</h5>
                    {Data2.map((item, idx) => (
                      <p key={idx} className="new-data-item" onClick={() => handleShowtrainer(item)}>
                        {cookiedata === "en" ? window.textTransform(item?.NameEn) : item.NameAr}
                      </p>
                    ))}
                  </div>
                )}
                {Data3.length > 0 && (
                  <div className="mobile-category-section">
                    <h5 className="new-result-header">{t('Owner')}</h5>
                    {Data3.map((item, idx) => (
                      <p key={idx} className="new-data-item" onClick={() => handleShowowner(item)}>
                        {cookiedata === "en" ? <>{item.TitleEn} {window.textTransform(item?.NameEn)} </> : <>{item.TitleAr} {item.NameAr} </>}
                      </p>
                    ))}
                  </div>
                )}
                {Data.length === 0 && Data2.length === 0 && Data3.length === 0 && Data4.length === 0 && (
                  <p className="new-no-data" style={{textAlign: 'center', padding: '20px'}}>{t('NoDataFound')}</p>
                )}
              </div>
            </>
          ) : (
            <div className="new-loader-container">
              <Lottie animationData={Animate} loop={true} className="new-lottie-loader" />
            </div>
          )}
        </div>


      </div>

      {/* Modals remain the same as they were */}
      <Modal show={show} onHide={handleClose} size="lg" centered>
        <Modal.Header className="popupheader" closeButton></Modal.Header>
        <Modal.Body><HorseDetail data={modaldata} /></Modal.Body>
      </Modal>

      <Modal show={showJocley} onHide={handleCloseJockey} size="lg" centered>
        <Modal.Header className="popupheader" closeButton></Modal.Header>
        <Modal.Body><JockeyDetail data={modaldataJockey} /></Modal.Body>
      </Modal>

      <Modal show={showtrainer} onHide={handleClosetrainer} size="lg" centered>
        <Modal.Header className="popupheader" closeButton></Modal.Header>
        <Modal.Body><TrainerDetail data={modaldatatrainer} /></Modal.Body>
      </Modal>

      <Modal show={showowner} onHide={handleCloseowner} size="lg" centered>
        <Modal.Header className="popupheader" closeButton></Modal.Header>
        <Modal.Body><OwnerDetail data={modaldataowner} /></Modal.Body>
      </Modal>
    </div>
  );
};
export default Search;